import styled from 'styled-components';
import { CROP_INFOS } from '../constants';
import { BREAKPOINTS } from '../../../utils/responsive';

const Container = styled.div`
  height: fit-content;
  color: #000;

  padding: 0 6px;
  font-size: 12px;
  @media (min-width: ${BREAKPOINTS.xs}) {
    padding: 0 8px;
    font-size: 13px;
  }
  @media (min-width: ${BREAKPOINTS.md}) {
    padding: 0 12px;
    font-size: 15.6px;
  }
`;

const CropInfo = ({ currentCropName }) => {
  const { description = null } = CROP_INFOS[currentCropName] ?? {};
  return <Container>{description}</Container>;
};

export default CropInfo;
